import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useCurrency } from '../../../contexts/CurrencyContext';
import { formatCurrency } from '../../../utils/currency';
import { Text } from '../../typography';

export interface SuggestedPriceProps {
    price: number;
    hideLabel?: boolean;
    id?: string;
}

export const SuggestedPrice: FC<SuggestedPriceProps> = ({ price, hideLabel, id }) => {
    const currency = useCurrency();
    const intl = useIntl();
    const formattedPrice = formatCurrency(price, currency, intl.locale);

    return (
        <Flex id={id}>
            {!hideLabel && (
                <Text color="slt-pepper.700" size="small">
                    <FormattedMessage id="suggested" defaultMessage="Sugg." />
                </Text>
            )}
            <Text size="small" type="cross" color="slt-pepper.900">
                {formattedPrice}
            </Text>
        </Flex>
    );
};
